var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFiscalized(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.375 6.6875C9.04688 6.6875 8.8125 6.94531 8.8125 7.25C8.8125 7.57812 9.04688 7.8125 9.375 7.8125C9.67969 7.8125 9.9375 7.57812 9.9375 7.25C9.9375 6.94531 9.67969 6.6875 9.375 6.6875ZM10.125 4.625V2.84375C10.125 2.5625 9.98438 2.25781 9.77344 2.04688L8.57812 0.851562C8.36719 0.640625 8.0625 0.5 7.78125 0.5H2.57812C2.17969 0.5 1.875 0.851562 1.875 1.25V4.625C0.820312 4.625 0 5.46875 0 6.5V9.5C0 9.71094 0.164062 9.875 0.375 9.875H1.875V12.125C1.875 12.3359 2.03906 12.5 2.25 12.5H9.75C9.9375 12.5 10.125 12.3359 10.125 12.125V9.875H11.625C11.8125 9.875 12 9.71094 12 9.5V6.5C12 5.46875 11.1562 4.625 10.125 4.625ZM3 1.625H7.5V2.75C7.5 2.96094 7.66406 3.125 7.875 3.125H9V4.625H3V1.625ZM9 11.375H3V9.875H9V11.375ZM10.875 8.75H1.125V6.5C1.125 6.10156 1.45312 5.75 1.875 5.75H10.125C10.5234 5.75 10.875 6.10156 10.875 6.5V8.75Z",
    fill: "#6C757D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiscalized);
export default __webpack_public_path__ + "static/media/fiscalized.b388a946.svg";
export { ForwardRef as ReactComponent };